import {
  SPI,
  DialogViewActionWidget,
  ActionType,
  BaseActionWidget,
  PopupSubmitParameters,
  PushActiveRecordsPredict,
  ViewActionTarget
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseActionWidget.Token({
    actionType: [ActionType.View],
    target: [ViewActionTarget.Dialog],
    name: 'uiViewfc78f6fdccbe48a59bee46efa83ea141'
  })
)
export class MyDialogViewActionWidget extends DialogViewActionWidget {
  initialize(props: any) {
    super.initialize(props);
    return this;
  }

  protected pushDataSourceForSubmit(parameters: PopupSubmitParameters, predict?: PushActiveRecordsPredict) {
    let { showRecords, submitRecords } = parameters;

    if (showRecords?.length) {
      const newArr: any[] = [];
      showRecords.forEach((i) => {
        if (this.dataSource?.every((j) => j.id !== i.id && j.merchBillName !== i.merchBillName)) {
          newArr.push(i);
        }
      });
      showRecords = newArr;
      submitRecords = newArr;
    }

    super.pushDataSourceForSubmit(parameters, predict);
  }
}
